import React from 'react/addons'
import Tbl from './Tbl'
import buildDict from './buildDict'
import inCart from 'lib/inCart'

let cx = React.addons.classSet
let getRealScrollX = () => Math.max(0, Math.min(window.scrollX, document.documentElement.scrollWidth - window.innerWidth))
let fixedHeaderHeight = document.querySelector('.js-menu').offsetHeight

const ComplexTable = React.createClass({

	mixins: [React.addons.PureRenderMixin],

	getInitialState() {
		return {
			sightPos: {
				width: 0,
				height: 0,
				left: -9999,
				top: -9999
			},
			fixed: false,
			bottom: false,
			currentCol: null,
			currentRow: null
		}
	},

	propTypes: {
		data: React.PropTypes.arrayOf(React.PropTypes.shape({
			d: React.PropTypes.number.isRequired,
			mass: React.PropTypes.number.isRequired,
			thick: React.PropTypes.number.isRequired,
			name: React.PropTypes.string.isRequired,
		})).isRequired,
		customCols: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
		customCells: React.PropTypes.object.isRequired,
		cols: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
		rows: React.PropTypes.arrayOf(React.PropTypes.number).isRequired,
	},

	componentWillMount() {
		const dict = buildDict(
			this.props.data,
			this.props.customCols,
			this.props.customCells
		);

		this.setState({
			dict,
			initialDict: dict
		})

		document.addEventListener('scroll', this.handleScroll)
	},

	componentWillUnmount() {
		document.removeEventListener('scroll', this.handleScroll)
	},

	componentWillReceiveProps(nextProps) {
		// console.log('cwr')
		this.setState({
			dict: buildDict(
				nextProps.data,
				nextProps.customCols,
				nextProps.customCells
			)
		})
	},

	handleScroll() {
		let el = this.getDOMNode()
		let elRect = el.getBoundingClientRect()

		if(elRect.bottom - 300 < fixedHeaderHeight && elRect.top < fixedHeaderHeight) {
			this.setState({fixed: false, bottom: true})
		} else if(elRect.top < fixedHeaderHeight) {
			this.setState({fixed: true, bottom: false})
			this.refs.header.getDOMNode().style.marginLeft = -getRealScrollX() + 'px'
		} else if(elRect.top > fixedHeaderHeight) {
			this.setState({fixed: false, bottom: false})
		}
	},

	getReactid(el) {
		return (el && el.dataset && el.dataset.reactid) || ''
	},

	handleSightMouseOut(evt) {
		let sightId = this.getReactid(this.refs.sight.getDOMNode())
		let relId = this.getReactid(evt.relatedTarget)
		if(relId.indexOf(sightId) !== -1 || sightId.length === 0 && relId.length === 0) {
			return
		}
		this.setState({
			sightPos: {
				top: -9999,
				left: -9999
			},
			currentCol: null,
			currentRow: null
		})
	},

	handleCurrentChange(currentRow, currentCol, sightPos) {
		this.setState({currentRow, currentCol, sightPos})
	},

	handleSightClick(add) {
		let cur = this.state.dict.items[this.state.currentRow] && this.state.dict.items[this.state.currentRow][this.state.currentCol]
		add
			? this.props.onAddToCart(this.props.productId, cur.id)
			: this.props.onRemoveFromCart(this.props.productId, cur.id)
	},

	renderSight() {
		let cur = this.state.dict.items[this.state.currentRow] && this.state.dict.items[this.state.currentRow][this.state.currentCol]
		let done = cur && inCart(this.props.cart.items, cur.id, this.props.productId)
		let cl = cx({
			'sight': true,
			'sight--done': done
		})

		return (
			<div onMouseOut={this.handleSightMouseOut} className={cl} ref="sight" style={this.state.sightPos}>
				<a onClick={this.handleSightClick.bind(this, !done)}>
					{done ? 'Убрать из корзины' : 'В корзину'}
				</a>
			</div>
		)
	},

	render() {
		const { dict, initialDict } = this.state;
		let cols = this.props.cols.filter(col => dict.names.indexOf(col) !== -1)
		let rows = Object.keys(dict.items)

		let headerStyle = styles.header
		if(this.state.bottom) {
			headerStyle = styles.bottomFixedHeader
		} else if(this.state.fixed) {
			headerStyle = styles.fixedHeader
		}

		return (
			<div className="table-w" onMouseOut={this.handleTblMouseOut}>
				<Tbl
					dict={dict}
					initialDict={initialDict}
					cols={cols}
					rows={rows}
					cart={this.props.cart}
					productId={this.props.productId}
					customCols={this.props.customCols}
					customCells={this.props.customCells}
					currentRow={this.state.currentRow}
					currentCol={this.state.currentCol}
					onCurrentChange={this.handleCurrentChange} />

				<div style={headerStyle} ref="header">
					<Tbl
						dict={dict}
						initialDict={initialDict}
						cols={cols}
						rows={rows.slice(Math.floor(rows.length/2), Math.floor(rows.length/2) + 1)}
						cart={this.props.cart}
						productId={this.props.productId}
						customCols={this.props.customCols}
						customCells={this.props.customCells}
						currentRow={this.state.currentRow}
						currentCol={this.state.currentCol}
						/>
				</div>

				{this.renderSight()}
			</div>
		)
	}
})

module.exports = ComplexTable

let styles = {
	header: {
		position: 'absolute',
		zIndex: 1,
		height: 88,
		top: 0,
		left: 0,
		marginLeft: 0,
		overflow: 'hidden'
	},
	fixedHeader: {
		position: 'fixed',
		zIndex: 1,
		height: 88,
		top: fixedHeaderHeight,
		overflow: 'hidden'
	},
	bottomFixedHeader: {
		position: 'absolute',
		zIndex: 1,
		height: 88,
		bottom: 212,
		marginLeft: 0,
		overflow: 'hidden'
	}
}


/** WEBPACK FOOTER **
 ** ./src/scripts/components/ComplexTable/ComplexTable.js
 **/